globalThis.appVisitor = globalThis.appVisitor || {};

appVisitor.ElementImage = (function() {
    function ElementImage($html) {
        this.$html   = $html;
        this.items   = [];
        this.imageId = this.$html.attr('id').match(/\d+/)[0]
        this.init();
    }

    ElementImage.prototype = {
        init : function() {
            this._getItems();
            this.events();
            hash = this._parseHash();
            if(hash.gid && hash.gid == this.imageId && hash.pid && !/album-\d+/.test(hash.pid)) {
                this.$html.trigger('click');
            }
        },
        events : function() {
            var me    = this,
                $pswp = $('.pswp')[0];

            this.$html.on('click', function(e) {
                e.preventDefault();

                var $this = $(this);

                utils.require([assets.photoswipe], function() {
                  if(appVisitor.headerMobile) appVisitor.headerMobile.disabled = true;

                  $('body').addClass('no-scroll');

                  var $index  = $this.index(),
                      options = {
                          galleryUID: me.imageId,
                          index: $index,
                          showHideOpacity: true,
                          shareButtons: [
                              { id:'facebook', label:'Partager sur Facebook', url:'https://www.facebook.com/sharer/sharer.php?u={{url}}' },
                              { id:'twitter', label:'Tweeter', url:'https://twitter.com/intent/tweet?text={{text}}&url={{url}}' },
                              { id:'pinterest', label:'Pin it', url:'http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}' },
                              { id:'download', label:'Télécharger l\'image', url:'{{raw_image_url}}', download:true }
                          ]
                      }

                  me.pswp = new PhotoSwipe($pswp, PhotoSwipeUI_Default, me.items, options);

                  me.pswp.listen('close', function() {
                      $('body').removeClass('no-scroll');
                      if(appVisitor.headerMobile) appVisitor.headerMobile.disabled = false;
                  });

                  me.pswp.init();
                });
            });
        },
        _parseHash : function() {
            var hash = window.location.hash.substring(1),
            params = {};

            if(hash.length < 5) {
                return params;
            }

            var vars = hash.split('&');
            for (var i = 0; i < vars.length; i++) {
                if(!vars[i]) {
                    continue;
                }
                var pair = vars[i].split('=');
                if(pair.length < 2) {
                    continue;
                }
                params[pair[0]] = pair[1];
            }

            if(params.gid) {
                params.gid = parseInt(params.gid, 10);
            }

            return params;
        },
        _getItems : function() {
            var me = this;
            this.$html.find('a').each(function(index, value) {
                var $this  = $(this),
                    href   = $this.attr('href'),
                    size   = $this.data('size').split('x'),
                    width  = size[0],
                    height = size[1];

                var item = {
                    src   : href,
                    w     : width,
                    h     : height,
                    title : $this.data('legend'),
                    el    : $this[0]
                }

                me.items.push(item);
            });
        }
    }

    return ElementImage;
})();
